import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENTID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

export const trackEvent = (eventName, eventParams) => {
  if (analytics) {
    const paramsWithDebug = { ...eventParams, debug_mode: true };
    logEvent(analytics, eventName, paramsWithDebug);
    console.log(`[Firebase Event]: ${eventName}`, paramsWithDebug);
  } else {
    console.warn(`[Firebase Analytics] Not initialized. Cannot track: ${eventName}`);
  }
};

export default app;
